import React from 'react';
import { TrendingUp, TrendingDown, DollarSign, Wallet } from 'lucide-react';

/**
 * StatCards - Premium financial summary cards
 * Responsive, glassmorphism, and modern animations
 */
export default function StatCards({ summary, formatCurrency }) {
    if (!summary) return null;

    const cards = [
        {
            title: 'Toplam Gelir',
            value: summary.income?.total || 0,
            icon: TrendingUp,
            color: 'from-emerald-500 to-teal-600',
            bgGlow: 'bg-emerald-500/20',
            iconColor: 'text-emerald-500',
        },
        {
            title: 'Toplam Gider',
            value: summary.expense?.total || 0,
            icon: TrendingDown,
            color: 'from-rose-500 to-pink-600',
            bgGlow: 'bg-rose-500/20',
            iconColor: 'text-rose-500',
        },
        {
            title: 'Net Bakiye',
            value: summary.netBalance || 0,
            icon: DollarSign,
            color: 'from-blue-500 to-indigo-600',
            bgGlow: 'bg-blue-500/20',
            iconColor: 'text-blue-500',
        },
        {
            title: 'Bekleyen Alacak',
            value: summary.collections?.pending || 0,
            icon: Wallet,
            color: 'from-amber-500 to-orange-600',
            bgGlow: 'bg-amber-500/20',
            iconColor: 'text-amber-500',
        }
    ];

    return (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-6">
            {cards.map((card, idx) => (
                <div
                    key={idx}
                    className="relative group overflow-hidden bg-white/60 dark:bg-bg-secondary/40 backdrop-blur-xl border border-white/40 dark:border-white/5 rounded-3xl p-4 md:p-6 transition-all duration-300 hover:scale-[1.02] hover:shadow-2xl hover:shadow-black/5"
                >
                    {/* Background Glow Effect */}
                    <div className={`absolute -right-4 -top-4 w-24 h-24 ${card.bgGlow} blur-3xl rounded-full transition-opacity duration-500 group-hover:opacity-100 opacity-40`} />

                    <div className="relative flex flex-col items-start gap-3 sm:gap-4">
                        {/* Icon Container */}
                        <div className={`p-2.5 sm:p-3 rounded-2xl bg-white dark:bg-neutral-800 shadow-sm border border-neutral-100 dark:border-neutral-700/50 ${card.iconColor} group-hover:scale-110 transition-transform duration-300`}>
                            <card.icon size={20} className="sm:w-6 sm:h-6" />
                        </div>

                        {/* Text Content */}
                        <div className="space-y-0.5 sm:space-y-1">
                            <p className="text-[10px] sm:text-xs md:text-sm font-semibold tracking-wide uppercase text-text-tertiary/70 group-hover:text-text-tertiary transition-colors">
                                {card.title}
                            </p>
                            <h3 className={`text-sm sm:text-xl md:text-2xl lg:text-3xl font-black tracking-tight text-text-primary`}>
                                {formatCurrency(card.value)}
                            </h3>
                        </div>
                    </div>

                    {/* Decorative Bottom Bar */}
                    <div className={`absolute bottom-0 left-0 h-1 md:h-1.5 transition-all duration-500 bg-gradient-to-r ${card.color} w-0 group-hover:w-full`} />
                </div>
            ))}
        </div>
    );
}
